







import { Component, Prop, Vue } from "vue-property-decorator";

import HttpService from "@/shared/services/http-service";
import PagesService from "./services/pages-service";

import { Page } from './models/page-viewmodel';

@Component({
})
export default class FavoritePageButtonComponent extends Vue {
    @Prop() public labelsJson!: string;

    get labels(): any {
        return JSON.parse(this.labelsJson);
    }

    public url: string = this.getPageUrl();
    public title: string = this.getPageTitle();
    public pages: Page[] = [];

    mounted() {
        this.init();
    }

    private getPageUrl(): string {
        return window.location.pathname;
    }

    private getPageTitle(): string {
        const element: HTMLMetaElement | null = document.head.querySelector("meta[property='og:site_name']");

        if(!element)
            return document.title;

        var pattern = ` - ${element.content}$`;
        let regex = new RegExp(pattern);

        return document.title.replace(regex, '');
    }

    get isFavorite() {
        return this.pageByUrl() || false;
    }

    private pageByUrl() {
        let found = this.pages.filter(page => page.url === this.url);
        return found && found.length > 0 ? found[0] : null;
    }

    private init(): void {
        this.startup();
    }

    private startup(): void {
        try {
            this.loadFavoritesPages();
        } catch (error) {
            console.error(error);
        }
    }

    private loadFavoritesPages(): void {
        PagesService.getMyFavoritePages(HttpService)
        .then(pages => {
            this.pages = pages;
        })
        .catch(error => {
            console.error(error);
        });
    }

    public removeFavorite(page: Page) {
        PagesService.removeFavoritePage(HttpService, page.id)
        .then(() => {
            this.loadFavoritesPages();
        })
        .catch((error) => {
            console.error(error);
        });
    }

    public addFavorite(url: string, title: string) {
        PagesService.addFavoritePage(HttpService, {url: url, title: title})
        .then(() => {
            this.loadFavoritesPages()
        })
        .catch((error) => {
            console.error(error);
        });
    }
}
